import * as React from 'react'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import SettingsEvent from 'modules/attendance/components/SettingItemPage/TimeTracking/SettingsPanel/_Item/_SettingsEvent'
import { useSettingsEvents } from 'modules/attendance/store/collections/settingsEvents'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
  loading: boolean
}

const Content = ({ attendanceSetting, loading }: Props) => {
  const settingsEventsCollection = useSettingsEvents()
  const settingsEvents = settingsEventsCollection.bySetting(attendanceSetting.attributes.id)

  if (loading) {
    return (
      <Box padding="s16" alignItems="center" justifyContent="center" flexGrow>
        <Spinner />
      </Box>
    )
  }

  if (!settingsEvents.length) {
    return (
      <Box padding="s16" alignItems="center" justifyContent="center" flexGrow>
        <Text size="200" color="grey800" weight="medium">
          {i18n.t('time_tracking.settings.versions.sidepanel.no_changes')}
        </Text>
      </Box>
    )
  }

  return (
    <>
      {settingsEvents.map((settingsEvent) => (
        <SettingsEvent key={settingsEvent.attributes.timestamp} settingsEvent={settingsEvent} />
      ))}
    </>
  )
}

export default observer(Content)
